import axios from 'axios';
import {backendHost} from '../../config';

export const putChangeDeleteLandings = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/landings/change-delete`, params);
};